import dayjs from "dayjs";
import TermsComp20250331 from "./v20250331";
import TermsComp20260601 from "./v20260601";

// 통합 이용약관
const index = () => {
    // 6월 1일 부로 개정
    const isChangeTerms = dayjs().isAfter("2026-05", "month");

    return (
        <>
            {/* {isChangeTerms ? <TermsComp20260601 /> : <TermsComp20250331 />} */}
            <TermsComp20260601 />
        </>
    );
};
export default index;
